module.exports = __webpack_public_path__ + "static/mypo-5e40241458233d1c48b5456d27a02c4f.jpg";